module.exports = __webpack_public_path__ + "static/media/card-design-thinkingof-you.07238f63.png";